import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

// Cedar rebrand: the former side-drawer navigation now lives in a top-bar dropdown.
// The trigger mirrors the user-menu button styling so the toolbar reads as one cluster.
export const useStyles = makeStyles((theme: Theme) => ({
    trigger: {
        display: "flex !important",
        gap: "6px !important",
        fontSize: "14px !important",
        fontWeight: "400 !important",
        fontFamily: "Source Sans 3 !important",
        color: `${theme.palette.menu.icons.main} !important`,
        textTransform: "none !important" as "none",
        whiteSpace: "nowrap",
        "&:hover": {
            backgroundColor: "initial !important",
            color: `${theme.palette.info.main} !important`,
        },
    },
    expandIcon: {
        width: "16px !important",
        height: "16px !important",
    },
    expandIconOpen: {
        width: "16px !important",
        height: "16px !important",
        transform: "rotate(180deg) !important",
    },
    paper: {
        width: 320,
        maxHeight: "min(70vh, 540px)",
        overflowY: "auto",
        marginTop: "8px !important",
        borderRadius: "10px !important",
        border: `1px solid ${theme.palette.border.select}`,
        boxShadow: "0 14px 34px rgba(6,35,63,0.12) !important",
    },
    list: {
        paddingTop: "8px !important",
        paddingBottom: "8px !important",
    },
}));
